// TradingViewWidget.jsx

import React, { useEffect, useRef } from "react";

let tvScriptLoadingPromise;

export default function TradingViewWidget() {
  const onLoadScriptRef = useRef();

  useEffect(() => {
    onLoadScriptRef.current = createWidget;

    if (!tvScriptLoadingPromise) {
      tvScriptLoadingPromise = new Promise((resolve) => {
        const script = document.createElement("script");
        script.id = "tradingview-widget-loading-script";
        script.src = "https://s3.tradingview.com/tv.js";
        script.type = "text/javascript";
        script.onload = resolve;

        document.head.appendChild(script);
      });
    }

    tvScriptLoadingPromise.then(
      () => onLoadScriptRef.current && onLoadScriptRef.current()
    );

    return () => (onLoadScriptRef.current = null);

    function createWidget() {
      if (
        document.getElementById("tradingview_2e50d") &&
        "TradingView" in window
      ) {
        new window.TradingView.widget({
          width: '100%',
          height: 610,
          symbol: "IDX:MPXL",
          interval: "D",
          timezone: "Asia/Jakarta",
          theme: "light",
          style: "1",
          locale: "id",
          toolbar_bg: "#f1f3f6",
          enable_publishing: false,
          container_id: "tradingview_2e50d",
        });
      }
    }
  }, []);

  return (
    <div className="tradingview-widget-container">
      <div id="tradingview_2e50d" />
      <div className="tradingview-widget-copyright">
        <a
          href="https://id.tradingview.com/"
          rel="noopener nofollow noreferrer"
          target="_blank"
        >
          <span className="blue-text">Lacak seluruh pasar di TradingView</span>
        </a>
      </div>
    </div>
  );
}
